<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <div>
        <runEnvironment-left ref='environmentLeft' @getSelectItem='getSelectItem'></runEnvironment-left>
      </div>
    </template>
    <template v-slot:right_view>
      <div id="DP" v-if="selectEnvironmentId === 'list-1'">
        <!--<RuningEnviromentListPage></RuningEnviromentListPage>-->
        <DPEnvironment></DPEnvironment>
      </div>
      <div id="KS" v-else-if="selectEnvironmentId === 'list-2'" style="height: 100%;padding-top: 20px;">
        <kubernetesEnvironment></kubernetesEnvironment>
      </div>
      <div id="BS" v-else-if="selectEnvironmentId === 'list-3'">
        <BSDeviceList></BSDeviceList>
      </div>
      <div id="SD" v-else-if="selectEnvironmentId === 'list-4'">
        <ServicePage></ServicePage>
      </div>
      <div id="OS" v-else-if="selectEnvironmentId === 'list-5'">
        <VersionUpdate></VersionUpdate>
      </div>
      <div id="AL" v-else-if="selectEnvironmentId === 'list-6'">
        <VersionPatch></VersionPatch>
      </div>
      <div id="BV" v-else-if="selectEnvironmentId === 'list-7'">
        <LibManager></LibManager>
      </div>
      <div id="WY" v-else-if="selectEnvironmentId === 'list-8'">
        <NetElementList></NetElementList>
      </div>
      <div id="PV" v-else-if="selectEnvironmentId === 'list-9'">
      
      </div>
      <div id="BK" v-else-if="selectEnvironmentId === 'list-10'">
          <VersionBack></VersionBack>
      </div>
      <div id="TP" v-else-if="selectEnvironmentId === 'list-11'">
          <TscIpAutoDistributePage></TscIpAutoDistributePage>
      </div>
      <div id="CT" v-else-if="selectEnvironmentId === 'list-12'">
          <TrackTaskList></TrackTaskList>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import RunEnvironmentLeft from '@/components/deploymentManagement/runningEnvironment/RunEnvironmentLeft';
import BSDeviceList from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/BSDeviceList';
import RuningEnviromentListPage from './runingEnviromentListPage';
import kubernetesEnvironment from '../kubernetesEnvironment/KubernetesEnv';
import ServicePage from '@/components/deploymentManagement/runningEnvironment/ServerEnvironment/ServicePage';
import DPEnvironment from '../dpEnvironment/DPEnvironment';
import VerlibList from '../../../components/software/VerlibList';
import PatchVerlibList from '../../../components/software/PatchVerlibList';
import NetElementList from '../../../components/software/NetElementList';

import VersionUpdate from "../../software/VersionUpdate";
import VersionPatch from "../../software/VersionPatch";
import VersionBack from "../../software/VersionBack";

import LibManager from "../../software/LibManager";

import TscIpAutoDistributePage from "../../software/TscIpAutoDistributePage";
import TrackTaskList from '../../../components/system/batchInitNe/BatchInitNeCfgList';

export default {
  name: "run-environment",
  components: {
    DPEnvironment,
    BasicLayout,
    RunEnvironmentLeft,
    BSDeviceList,
    RuningEnviromentListPage,
    kubernetesEnvironment,
    ServicePage,
    VerlibList,
    NetElementList,
    PatchVerlibList,
    VersionUpdate,
    VersionPatch,
    VersionBack,
    LibManager,
    TscIpAutoDistributePage,
    TrackTaskList
  },
  props: {},
  computed: {
    crumb() {
      return `${this.menu.name}/${this.selectEnvironmentName}`;
    }
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('DeployManagement.runEnvironment'),
      },
      middle: {
        show: false,
        name: 'mo'
      },
      right: {
        show: true,
        crumb: `${this.$t('DeployManagement.runEnvironment')}/${this.$t('DeployManagement.poc')}`,
      },
      menu: {
        show: true,
        name: `${this.$t('DeployManagement.deployManagement')}/${this.$t('DeployManagement.environmentConfig')}`,
      },
      selectEnvironmentId: 'list-1',
      selectEnvironmentName: '',
    }
  },

  methods: {
    getSelectItem(id, name) {
      this.selectEnvironmentId = id;
      this.selectEnvironmentName = name;
      this.right.crumb = this.crumb;
      console.log('BSMain 选中环境:', id, name);
    },
  }
};
</script>
